import Swiper from 'swiper'

export default class productSlider {

    constructor(element) {
        this.element = element
        this.swiperSettings = {
            speed: 400,
            loop: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            centerInsufficientSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    centeredSlides: false
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
            }
        }
        this.swiper = new Swiper(this.element, this.swiperSettings)
    }

}